import { TypePolicy } from '@apollo/client'

const ChannelAttribution: TypePolicy = {
  keyFields: ['channelAttributionId'],
}

export default ChannelAttribution
